import { replace, trimStart } from 'lodash';

import { HIDDEN_LANGUAGE, LANGUAGE } from 'src/data/generation';

export const TONE_OF_VOICE_TRAIT = {
  formal: 'formal',
  friendly: 'friendly',
  authentic: 'authentic',
  matterOfFact: 'matter-of-fact',
  enthusiastic: 'enthusiastic',
  conversational: 'conversational',
  informative: 'informative',
  confident: 'confident',
  empathetic: 'empathetic',
  humorous: 'humorous',
  witty: 'witty',
  persuasive: 'persuasive',

  respectful: 'respectful',
  creative: 'creative',
};

export const TONE_OF_VOICE_TRAIT_NON_ENGLISH = {
  [LANGUAGE.de]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formell',
    [TONE_OF_VOICE_TRAIT.friendly]: 'freundlich',
    [TONE_OF_VOICE_TRAIT.authentic]: 'authentisch',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'sachlich',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'enthusiastisch',
    [TONE_OF_VOICE_TRAIT.conversational]: 'gesprächig',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativ',
    [TONE_OF_VOICE_TRAIT.confident]: 'selbstbewusst',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'einfühlsam',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humorvoll',
    [TONE_OF_VOICE_TRAIT.witty]: 'witzig',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'überzeugend',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respektvoll',
    [TONE_OF_VOICE_TRAIT.creative]: 'kreativ',
  },
  [LANGUAGE.de_in]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'Formal',
    [TONE_OF_VOICE_TRAIT.friendly]: 'freundlich',
    [TONE_OF_VOICE_TRAIT.authentic]: 'authentisch',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'sachlich',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Begeistert',
    [TONE_OF_VOICE_TRAIT.conversational]: 'Gesprächig',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativ',
    [TONE_OF_VOICE_TRAIT.confident]: 'selbstbewusst',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'Empathisch',
    [TONE_OF_VOICE_TRAIT.humorous]: 'Humorvoll',
    [TONE_OF_VOICE_TRAIT.witty]: 'Schlagfertig',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'überzeugend',
    [TONE_OF_VOICE_TRAIT.respectful]: 'Respektvoll',
    [TONE_OF_VOICE_TRAIT.creative]: 'kreativ',
  },
  [LANGUAGE.el]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'Επίσημος',
    [TONE_OF_VOICE_TRAIT.friendly]: 'Φιλικός',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Αυθεντικός',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Περιγραφικός',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Ενθουσιώδης',
    [TONE_OF_VOICE_TRAIT.conversational]: 'Συνομιλητικός',
    [TONE_OF_VOICE_TRAIT.informative]: 'Ενημερωτικός',
    [TONE_OF_VOICE_TRAIT.confident]: 'Σίγουρος',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'Εμφατικός',
    [TONE_OF_VOICE_TRAIT.humorous]: 'Χιουμοριστικός',
    [TONE_OF_VOICE_TRAIT.witty]: 'Πνευματώδης',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'Πειστικός',
    [TONE_OF_VOICE_TRAIT.respectful]: 'Σεβαστικός',
    [TONE_OF_VOICE_TRAIT.creative]: 'Δημιουργικός',
  },
  [LANGUAGE.es]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formal',
    [TONE_OF_VOICE_TRAIT.friendly]: 'amigable',
    [TONE_OF_VOICE_TRAIT.authentic]: 'auténtico',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'objetivo',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'entusiasta',
    [TONE_OF_VOICE_TRAIT.conversational]: 'conversacional',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativo',
    [TONE_OF_VOICE_TRAIT.confident]: 'seguro',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'Empático',
    [TONE_OF_VOICE_TRAIT.humorous]: 'Humorístico',
    [TONE_OF_VOICE_TRAIT.witty]: 'agudo',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'persuasivo',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respetuoso',
    [TONE_OF_VOICE_TRAIT.creative]: 'creativo',
  },
  [LANGUAGE.es_la]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'Formal',
    [TONE_OF_VOICE_TRAIT.friendly]: 'Amigable',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Auténtico',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Objetivo',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Entusiasta',
    [TONE_OF_VOICE_TRAIT.conversational]: 'Conversacional',
    [TONE_OF_VOICE_TRAIT.informative]: 'Informativo',
    [TONE_OF_VOICE_TRAIT.confident]: 'Seguro',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'Empático',
    [TONE_OF_VOICE_TRAIT.humorous]: 'Humorístico',
    [TONE_OF_VOICE_TRAIT.witty]: 'Ingenioso',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'Persuasivo',
    [TONE_OF_VOICE_TRAIT.respectful]: 'Respetuoso',
    [TONE_OF_VOICE_TRAIT.creative]: 'Creativo',
  },
  [LANGUAGE.es_cs]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'Formal',
    [TONE_OF_VOICE_TRAIT.friendly]: 'Amistoso',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Auténtico',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Objetivo',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Entusiasta',
    [TONE_OF_VOICE_TRAIT.conversational]: 'Conversacional',
    [TONE_OF_VOICE_TRAIT.informative]: 'Informativo',
    [TONE_OF_VOICE_TRAIT.confident]: 'Seguro',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'Empático',
    [TONE_OF_VOICE_TRAIT.humorous]: 'Humorístico',
    [TONE_OF_VOICE_TRAIT.witty]: 'Ingenioso',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'Persuasivo',
    [TONE_OF_VOICE_TRAIT.respectful]: 'Respetuoso',
    [TONE_OF_VOICE_TRAIT.creative]: 'Creativo',
  },
  [LANGUAGE.tr]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'resmi',
    [TONE_OF_VOICE_TRAIT.friendly]: 'Arkadaşça',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Otantik',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Somut',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Coşkulu',
    [TONE_OF_VOICE_TRAIT.conversational]: 'Sohbet dili',
    [TONE_OF_VOICE_TRAIT.informative]: 'bilgilendirici',
    [TONE_OF_VOICE_TRAIT.confident]: 'kendinden emin',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empatik',
    [TONE_OF_VOICE_TRAIT.humorous]: 'mizahi',
    [TONE_OF_VOICE_TRAIT.witty]: 'zeki',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'ikna edici',
    [TONE_OF_VOICE_TRAIT.respectful]: 'saygılı',
    [TONE_OF_VOICE_TRAIT.creative]: 'yaratıcı',
  },
  [LANGUAGE.fr]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formelle',
    [TONE_OF_VOICE_TRAIT.friendly]: 'amical',
    [TONE_OF_VOICE_TRAIT.authentic]: 'authentique',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'factuel',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'enthousiaste',
    [TONE_OF_VOICE_TRAIT.conversational]: 'conversationne',
    [TONE_OF_VOICE_TRAIT.informative]: 'informatif',
    [TONE_OF_VOICE_TRAIT.confident]: 'confiant',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empathique',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humouristique',
    [TONE_OF_VOICE_TRAIT.witty]: 'spirituel',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'persuasif',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respectueux',
    [TONE_OF_VOICE_TRAIT.creative]: 'créatif',
  },
  [LANGUAGE.fr_qu]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'Formel',
    [TONE_OF_VOICE_TRAIT.friendly]: 'Amical',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Authentique',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Factuel',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Enthousiaste',
    [TONE_OF_VOICE_TRAIT.conversational]: 'Conversant',
    [TONE_OF_VOICE_TRAIT.informative]: 'Informatif',
    [TONE_OF_VOICE_TRAIT.confident]: 'Confiant',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'Empathique',
    [TONE_OF_VOICE_TRAIT.humorous]: 'Humoristique',
    [TONE_OF_VOICE_TRAIT.witty]: "Plein d'esprit",
    [TONE_OF_VOICE_TRAIT.persuasive]: 'Persuasif',
    [TONE_OF_VOICE_TRAIT.respectful]: 'Respectueux',
    [TONE_OF_VOICE_TRAIT.creative]: 'Créatif',
  },
  [LANGUAGE.bg]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'формален',
    [TONE_OF_VOICE_TRAIT.friendly]: 'приятелски',
    [TONE_OF_VOICE_TRAIT.authentic]: 'автентичен',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'обективен',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'ентусиазиран',
    [TONE_OF_VOICE_TRAIT.conversational]: 'разговорен',
    [TONE_OF_VOICE_TRAIT.informative]: 'информативен',
    [TONE_OF_VOICE_TRAIT.confident]: 'уверен',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'емпатичен',
    [TONE_OF_VOICE_TRAIT.humorous]: 'хумористичен',
    [TONE_OF_VOICE_TRAIT.witty]: 'остроумен',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'убедителен',
    [TONE_OF_VOICE_TRAIT.respectful]: 'уважителен',
    [TONE_OF_VOICE_TRAIT.creative]: 'креативен',
  },
  [LANGUAGE.cs]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formální',
    [TONE_OF_VOICE_TRAIT.friendly]: 'přátelský',
    [TONE_OF_VOICE_TRAIT.authentic]: 'autentický',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Faktický',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'nadšený',
    [TONE_OF_VOICE_TRAIT.conversational]: 'konverzační',
    [TONE_OF_VOICE_TRAIT.informative]: 'Informativní',
    [TONE_OF_VOICE_TRAIT.confident]: 'sebevědomý',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empatický',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humorní',
    [TONE_OF_VOICE_TRAIT.witty]: 'bystrý',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'přesvědčivý',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respektující',
    [TONE_OF_VOICE_TRAIT.creative]: 'kreativní',
  },
  [LANGUAGE.da]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formel',
    [TONE_OF_VOICE_TRAIT.friendly]: 'venlig',
    [TONE_OF_VOICE_TRAIT.authentic]: 'autentisk',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'nøgtern',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'entusiastisk',
    [TONE_OF_VOICE_TRAIT.conversational]: 'samtale',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativ',
    [TONE_OF_VOICE_TRAIT.confident]: 'selvsikker',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empatisk',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humoristisk',
    [TONE_OF_VOICE_TRAIT.witty]: 'vittig',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'overbevisende',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respektfuld',
    [TONE_OF_VOICE_TRAIT.creative]: 'kreativ',
  },
  [LANGUAGE.nl]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formeel',
    [TONE_OF_VOICE_TRAIT.friendly]: 'vriendelijk',
    [TONE_OF_VOICE_TRAIT.authentic]: 'authentiek',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'feitelijk',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'enthousiast',
    [TONE_OF_VOICE_TRAIT.conversational]: 'gemoedelijk',
    [TONE_OF_VOICE_TRAIT.informative]: 'informatief',
    [TONE_OF_VOICE_TRAIT.confident]: 'zelfverzekerd',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empathisch',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humoristisch',
    [TONE_OF_VOICE_TRAIT.witty]: 'gevat',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'overtuigend',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respectvol',
    [TONE_OF_VOICE_TRAIT.creative]: 'creatief',
  },
  [LANGUAGE.hu]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formális',
    [TONE_OF_VOICE_TRAIT.friendly]: 'barátságos',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Autentikus',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Tényekre épülő',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'lelkes',
    [TONE_OF_VOICE_TRAIT.conversational]: 'társalgó',
    [TONE_OF_VOICE_TRAIT.informative]: 'Tudásos',
    [TONE_OF_VOICE_TRAIT.confident]: 'magabiztos',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empatikus',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humoros',
    [TONE_OF_VOICE_TRAIT.witty]: 'szellemes',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'meggyőző',
    [TONE_OF_VOICE_TRAIT.respectful]: 'tiszteletre méltó',
    [TONE_OF_VOICE_TRAIT.creative]: 'kreatív',
  },
  [LANGUAGE.it]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formale',
    [TONE_OF_VOICE_TRAIT.friendly]: 'amichevole',
    [TONE_OF_VOICE_TRAIT.authentic]: 'autentico',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Pragmatico',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'entusiasta',
    [TONE_OF_VOICE_TRAIT.conversational]: 'colloquiale',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativo',
    [TONE_OF_VOICE_TRAIT.confident]: 'sicuro',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empatico',
    [TONE_OF_VOICE_TRAIT.humorous]: 'umoristico',
    [TONE_OF_VOICE_TRAIT.witty]: 'spiritoso',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'persuasivo',
    [TONE_OF_VOICE_TRAIT.respectful]: 'rispettoso',
    [TONE_OF_VOICE_TRAIT.creative]: 'creativo',
  },
  [LANGUAGE.pl]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formalny',
    [TONE_OF_VOICE_TRAIT.friendly]: 'przyjazny',
    [TONE_OF_VOICE_TRAIT.authentic]: 'autentyczny',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'rzeczowy',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'entuzjastyczny',
    [TONE_OF_VOICE_TRAIT.conversational]: 'konwersacyjny',
    [TONE_OF_VOICE_TRAIT.informative]: 'informacyjny',
    [TONE_OF_VOICE_TRAIT.confident]: 'pewny siebie',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empatyczny',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humoryczny',
    [TONE_OF_VOICE_TRAIT.witty]: 'dowcipny',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'przekonujący',
    [TONE_OF_VOICE_TRAIT.respectful]: 'pełen szacunku',
    [TONE_OF_VOICE_TRAIT.creative]: 'kreatywny',
  },
  [LANGUAGE.pt_br]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formal',
    [TONE_OF_VOICE_TRAIT.friendly]: 'amigável',
    [TONE_OF_VOICE_TRAIT.authentic]: 'autêntico',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'objetivo',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'entusiasta',
    [TONE_OF_VOICE_TRAIT.conversational]: 'conversacional',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativo',
    [TONE_OF_VOICE_TRAIT.confident]: 'confiante',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empático',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humorístico',
    [TONE_OF_VOICE_TRAIT.witty]: 'sagaz',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'persuasivo',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respeitoso',
    [TONE_OF_VOICE_TRAIT.creative]: 'criativo',
  },
  [LANGUAGE.pt_pt]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formal',
    [TONE_OF_VOICE_TRAIT.friendly]: 'amigável',
    [TONE_OF_VOICE_TRAIT.authentic]: 'autêntico',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'objetivo',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'entusiasta',
    [TONE_OF_VOICE_TRAIT.conversational]: 'conversacional',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativo',
    [TONE_OF_VOICE_TRAIT.confident]: 'confiante',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empático',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humorístico',
    [TONE_OF_VOICE_TRAIT.witty]: 'sagaz',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'persuasivo',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respeitoso',
    [TONE_OF_VOICE_TRAIT.creative]: 'criativo',
  },
  [LANGUAGE.ro]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formal',
    [TONE_OF_VOICE_TRAIT.friendly]: 'prietenos',
    [TONE_OF_VOICE_TRAIT.authentic]: 'autentic',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Fără menajamente',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'entuziast',
    [TONE_OF_VOICE_TRAIT.conversational]: 'de conversaţie',
    [TONE_OF_VOICE_TRAIT.informative]: 'Informat',
    [TONE_OF_VOICE_TRAIT.confident]: 'încrezător',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empatic',
    [TONE_OF_VOICE_TRAIT.humorous]: 'umoristic',
    [TONE_OF_VOICE_TRAIT.witty]: 'spiritual',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'persuasiv',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respectuos',
    [TONE_OF_VOICE_TRAIT.creative]: 'creativ',
  },
  [LANGUAGE.ru]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'Формальный',
    [TONE_OF_VOICE_TRAIT.friendly]: 'Дружелюбный',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Аутентичный',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'Фактический',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Восторженный',
    [TONE_OF_VOICE_TRAIT.conversational]: 'разговорный',
    [TONE_OF_VOICE_TRAIT.informative]: 'Информативный',
    [TONE_OF_VOICE_TRAIT.confident]: 'Уверенный',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'Эмпатичный',
    [TONE_OF_VOICE_TRAIT.humorous]: 'Юмористичный',
    [TONE_OF_VOICE_TRAIT.witty]: 'Остроумный',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'Убедительный',
    [TONE_OF_VOICE_TRAIT.respectful]: 'Уважительный',
    [TONE_OF_VOICE_TRAIT.creative]: 'Креативный',
  },
  [LANGUAGE.de_ch]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'formell',
    [TONE_OF_VOICE_TRAIT.friendly]: 'freundlich',
    [TONE_OF_VOICE_TRAIT.authentic]: 'Authentisch',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'sachlich',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'Begeistert',
    [TONE_OF_VOICE_TRAIT.conversational]: 'Begeistert',
    [TONE_OF_VOICE_TRAIT.informative]: 'informativ',
    [TONE_OF_VOICE_TRAIT.confident]: 'selbstbewusst',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'empathisch',
    [TONE_OF_VOICE_TRAIT.humorous]: 'humorvoll',
    [TONE_OF_VOICE_TRAIT.witty]: 'schlagfertig',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'Überzeugend',
    [TONE_OF_VOICE_TRAIT.respectful]: 'respektvoll',
    [TONE_OF_VOICE_TRAIT.creative]: 'kreativ',
  },
  [LANGUAGE.cmn]: {
    [TONE_OF_VOICE_TRAIT.formal]: '正式',
    [TONE_OF_VOICE_TRAIT.friendly]: '友好',
    [TONE_OF_VOICE_TRAIT.authentic]: '真实',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: '事实性的',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: '热情',
    [TONE_OF_VOICE_TRAIT.conversational]: '交谈的',
    [TONE_OF_VOICE_TRAIT.informative]: '信息丰富的',
    [TONE_OF_VOICE_TRAIT.confident]: '自信',
    [TONE_OF_VOICE_TRAIT.empathetic]: '有同理心',
    [TONE_OF_VOICE_TRAIT.humorous]: '幽默',
    [TONE_OF_VOICE_TRAIT.witty]: '机智',
    [TONE_OF_VOICE_TRAIT.persuasive]: '有说服力',
    [TONE_OF_VOICE_TRAIT.respectful]: '尊重',
    [TONE_OF_VOICE_TRAIT.creative]: '有创意',
  },
  [LANGUAGE.yue]: {
    [TONE_OF_VOICE_TRAIT.formal]: '正式',
    [TONE_OF_VOICE_TRAIT.friendly]: '友善',
    [TONE_OF_VOICE_TRAIT.authentic]: '真正',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: '事實性',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: '熱情',
    [TONE_OF_VOICE_TRAIT.conversational]: '對話',
    [TONE_OF_VOICE_TRAIT.informative]: '資訊性',
    [TONE_OF_VOICE_TRAIT.confident]: '自信',
    [TONE_OF_VOICE_TRAIT.empathetic]: '有同理心',
    [TONE_OF_VOICE_TRAIT.humorous]: '幽默',
    [TONE_OF_VOICE_TRAIT.witty]: '機智',
    [TONE_OF_VOICE_TRAIT.persuasive]: '有說服力',
    [TONE_OF_VOICE_TRAIT.respectful]: '尊重',
    [TONE_OF_VOICE_TRAIT.creative]: '有創意',
  },
  [LANGUAGE.ja]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'フォーマル',
    [TONE_OF_VOICE_TRAIT.friendly]: 'フレンドリー',
    [TONE_OF_VOICE_TRAIT.authentic]: 'オーセンティック',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: '事実',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: '熱狂的',
    [TONE_OF_VOICE_TRAIT.conversational]: '会話',
    [TONE_OF_VOICE_TRAIT.informative]: '情報提供',
    [TONE_OF_VOICE_TRAIT.confident]: '自信',
    [TONE_OF_VOICE_TRAIT.empathetic]: '共感的な',
    [TONE_OF_VOICE_TRAIT.humorous]: 'ユーモラス',
    [TONE_OF_VOICE_TRAIT.witty]: '機知に富んだ',
    [TONE_OF_VOICE_TRAIT.persuasive]: '説得力のある',
    [TONE_OF_VOICE_TRAIT.respectful]: '尊敬',
    [TONE_OF_VOICE_TRAIT.creative]: 'クリエイティブ',
  },
  [HIDDEN_LANGUAGE.he]: {
    [TONE_OF_VOICE_TRAIT.formal]: 'רשמי',
    [TONE_OF_VOICE_TRAIT.friendly]: 'ידידותי',
    [TONE_OF_VOICE_TRAIT.authentic]: 'אותנטי',
    [TONE_OF_VOICE_TRAIT.matterOfFact]: 'ענייני',
    [TONE_OF_VOICE_TRAIT.enthusiastic]: 'נלהב',
    [TONE_OF_VOICE_TRAIT.conversational]: 'זורם',
    [TONE_OF_VOICE_TRAIT.informative]: 'אינפורמטיבי',
    [TONE_OF_VOICE_TRAIT.confident]: 'בטוח בעצמו',
    [TONE_OF_VOICE_TRAIT.empathetic]: 'אמפתי',
    [TONE_OF_VOICE_TRAIT.humorous]: 'הומוריסטי',
    [TONE_OF_VOICE_TRAIT.witty]: 'שנון',
    [TONE_OF_VOICE_TRAIT.persuasive]: 'משכנע',
    [TONE_OF_VOICE_TRAIT.respectful]: 'מכבד',
    [TONE_OF_VOICE_TRAIT.creative]: 'יצירתי',
  },
};

export const TOV_TRAIT_BUT_NOT_MAP = {
  [TONE_OF_VOICE_TRAIT.formal]: ['cold', 'corporate', 'old-fashioned'],
  [TONE_OF_VOICE_TRAIT.friendly]: ['unprofessional', 'overly familiar', 'overly casual'],
  [TONE_OF_VOICE_TRAIT.authentic]: ['unprofessional', 'overly casual', 'disrespectful'],
  [TONE_OF_VOICE_TRAIT.matterOfFact]: ['indifferent', 'monotonous'],
  [TONE_OF_VOICE_TRAIT.enthusiastic]: ['over-the-top', 'too salesy'],
  [TONE_OF_VOICE_TRAIT.conversational]: ['slangy', 'disrespectful'],
  [TONE_OF_VOICE_TRAIT.informative]: ['dry', 'overly technical', 'wordy'],
  [TONE_OF_VOICE_TRAIT.confident]: ['arrogant', 'bossy'],
  [TONE_OF_VOICE_TRAIT.empathetic]: ['dramatic', 'assumptive', 'patronizing'],
  [TONE_OF_VOICE_TRAIT.humorous]: ['inappropriate', 'childish', 'corny'],
  [TONE_OF_VOICE_TRAIT.witty]: ['irreverent', 'sarcastic', 'snarky'],
  [TONE_OF_VOICE_TRAIT.persuasive]: ['over-the-top', 'too salesy'],
  [TONE_OF_VOICE_TRAIT.respectful]: ['hesitant', 'distant', 'overly formal'],
  [TONE_OF_VOICE_TRAIT.creative]: ['quirky', 'abstract', 'exaggerated'],
};

// the order of array should be same as english so we can send correct values
export const NON_ENGLISH_TOV_TRAIT_BUT_NOT = {
  [LANGUAGE.de]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['kalt', 'geschäftlich', 'altmodisch'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['unprofessional', 'übermäßig vertraut', 'zu lässig'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['unprofessional', 'zu lässig', 'respektlos'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['gleichgültig', 'monoton'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['übertrieben', 'zu kommerziell'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['umgangssprachlich', 'respektlos'],
    [TONE_OF_VOICE_TRAIT.informative]: ['trocken', 'zu technisch', 'langatmig'],
    [TONE_OF_VOICE_TRAIT.confident]: ['arrogant', 'herrisch'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['dramatisch', 'anmaßend', 'herablassend'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['unangemessen', 'kindisch', 'kitschig'],
    [TONE_OF_VOICE_TRAIT.witty]: ['respektlos', 'sarkastisch', 'Bissig'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['übertrieben', 'zu kommerziell'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['zögerlich', 'distanziert', 'zu förmlich'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Schrullig', 'abstrakt', 'übertrieben'],
  },
  [LANGUAGE.de_in]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['kalt', 'geschäftlich', 'altmodisch'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['unprofessional', 'zu vertraut', 'zu lässig'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['unprofessional', 'zu lässig', 'respektlos'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['gleichgültig', 'Einseitig'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['übertrieben', 'zu verkäuferisch'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['umgangssprachlich', 'respektlos'],
    [TONE_OF_VOICE_TRAIT.informative]: ['trocken', 'zu technisch', 'wortreich'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Eingebildet', 'Bestimmerisch'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Übertrieben', 'anmaßend', 'Von oben herab'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Unangebracht', 'kindisch', 'Abgedroschen'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Frech', 'sarkastisch', 'Spitz'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['übertrieben', 'Zu verkäuferisch'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['zögerlich', 'distanziert', 'Zu steif'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Schrullig', 'Abgehoben', 'übertrieben'],
  },
  [LANGUAGE.el]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['Ψυχρός', 'Εταιρικός', 'Παλιομοδίτικος'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['Μη επαγγελματικός', 'Πολύ οικείος', 'Πολύ ανεπίσημος'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['Μη επαγγελματικός', 'Πολύ ανεπίσημος', 'Ασεβής'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['Αδιάφορος', 'Μονότονος'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['Υπερβολικός', 'Πολύ προωθητικός'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Καθομιλούμενος', 'Ασεβής'],
    [TONE_OF_VOICE_TRAIT.informative]: ['Ξηρός', 'Πολύ τεχνικός', 'Φλύαρος'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Αλαζονικός', 'Αυταρχικός'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Δραματικός', 'Υποθετικός', 'Εποπτικός'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Ακατάλληλος', 'Παιδαριώδης', 'Κιτς'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Ασεβής', 'Ειρωνικός', 'Καυστικός'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Υπερβολικός', 'Πολύ προωθητικός'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Διστακτικός', 'Απομακρυσμένος', 'Υπερβολικά επίσημος'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Παράξενος', 'Αφηρημένος', 'Υπερβολικός'],
  },
  [LANGUAGE.es]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['distante', 'corporativo', 'anticuado'],
    [TONE_OF_VOICE_TRAIT.friendly]: [
      'poco profesional',
      'demasiado familiar',
      'excessivamente casual',
    ],
    [TONE_OF_VOICE_TRAIT.authentic]: ['poco profesional', 'excessivamente casual', 'irrespetuoso'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['indiferente', 'monótono'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['exagerado', 'demasiado comercial'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['vulgar', 'irrespetuoso'],
    [TONE_OF_VOICE_TRAIT.informative]: ['seco', 'demasiado técnico', 'verboso'],
    [TONE_OF_VOICE_TRAIT.confident]: ['arrogante', 'mandón'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['dramático', 'presuntivo', 'condescendiente'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['inapropiado', 'infantil', 'cursi'],
    [TONE_OF_VOICE_TRAIT.witty]: ['irreverente', 'sarcástico', 'mordaz'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['exagerado', 'demasiado orientado a ventas'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['vacilante', 'distante', 'demasiado formal'],
    [TONE_OF_VOICE_TRAIT.creative]: ['peculiar', 'abstracto', 'exagerado'],
  },
  [LANGUAGE.es_la]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['Frío', 'Corporativo', 'Anticuado'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['No profesional', 'Demasiado familiar', 'Demasiado informal'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['No profesional', 'Demasiado informal', 'Irrespetuoso'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['Indiferente', 'Monótono'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['Exagerado', 'Demasiado enfocado en ventas'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Demasiado coloquial', 'Irrespetuoso'],
    [TONE_OF_VOICE_TRAIT.informative]: ['Seco', 'Demasiado técnico', 'Demasiado extenso'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogante', 'Autoritario'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramático', 'Presuntivo', 'Condescendiente'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Inapropiado', 'Infantil', 'Cursi'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Irrespetuoso', 'Sarcástico', 'Mordaz'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Exagerado', 'Demasiado comercial'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Vacilante', 'Distante', 'Demasiado formal'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Peculiar', 'Abstracto', 'Exagerado'],
  },
  [LANGUAGE.es_cs]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['Frío', 'Corporativo', 'Anticuado'],
    [TONE_OF_VOICE_TRAIT.friendly]: [
      'Poco profesional',
      'Demasiado informal',
      'Excesivamente casual',
    ],
    [TONE_OF_VOICE_TRAIT.authentic]: ['Poco profesional', 'Demasiado casual', 'Irrespetuoso'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['Indiferente', 'Monótono'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['Exagerado', 'Demasiado comercial'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Coloquial', 'Irrespetuoso'],
    [TONE_OF_VOICE_TRAIT.informative]: ['Seco', 'Demasiado técnico', 'Prolijo'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogante', 'Autoritario'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramático', 'Presumido', 'Condescendiente'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Inapropiado', 'Infantil', 'Cursi'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Irrespetuoso', 'Sarcástico', 'Mordaz'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Exagerado', 'Demasiado comercial'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Indeciso', 'Distante', 'Demasiado formal'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Excéntrico', 'Abstracto', 'Exagerado'],
  },
  [LANGUAGE.tr]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['soğuk', 'kurumsal', 'eski moda'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['profesyonel olmayan', 'aşırı samimi', 'aşırı gündelik'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['profesyonel olmayan', 'aşırı gündelik', 'saygısız'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['kayıtsız', 'monoton'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['abartılı', 'fazla satış odaklı'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['argo', 'saygısız'],
    [TONE_OF_VOICE_TRAIT.informative]: ['kuru', 'aşırı teknik', 'laf kalabalığı yapan'],
    [TONE_OF_VOICE_TRAIT.confident]: ['kibirli', 'otoriter'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['dramatik', 'varsayımcı', 'küçümseyici'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['uygunsuz', 'Çocuksu', 'Bayat'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Saygısız', 'Alaycı', 'İğneleyici'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['aşırı', 'fazla satış odaklı'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['tereddütlü', 'mesafeli', 'aşırı resmi'],
    [TONE_OF_VOICE_TRAIT.creative]: ['garip', 'soyut', 'abartılı'],
  },
  [LANGUAGE.fr]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['distant', 'corporatif', 'démodé'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['non professionnel', 'trop familier', 'trop décontracté'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['non professionnel', 'trop décontracté', 'irrespectueux'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['indifférent', 'monotone'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['excessif', 'trop commercial'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['argotique', 'irrespectueux'],
    [TONE_OF_VOICE_TRAIT.informative]: ['sec', 'trop technique', 'verbeux'],
    [TONE_OF_VOICE_TRAIT.confident]: ['arrogant', 'autoritaire'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['dramatique', 'présomptueux', 'condescendant'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['inapproprié', 'enfantin', 'ringard'],
    [TONE_OF_VOICE_TRAIT.witty]: ['irrespectueux', 'sarcastique', 'acerbe'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['exagéré', 'trop axé sur la vente'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['hésitant', 'distant', 'trop formel'],
    [TONE_OF_VOICE_TRAIT.creative]: ['excentrique', 'abstrait', 'exagéré'],
  },
  [LANGUAGE.fr_qu]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['Froid', 'Trop corporatif', 'Démodé'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['Non professionnel', 'Trop familier', 'Trop décontracté'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['Non professionnel', 'Trop décontracté', 'Irrespectueux'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['Indifférent', 'Monotone'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['Exagéré', 'Trop axé sur la vente'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Trop familier', 'Irrespectueux'],
    [TONE_OF_VOICE_TRAIT.informative]: ['Sec', 'Trop technique', 'Trop verbeux'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogant', 'Autoritaire'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramatique', 'Présomptueux', 'Condescendant'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Inapproprié', 'Enfantin', 'Cucul'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Irrévérencieux', 'Sarcastique', 'Acerbe'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Exagéré', 'Trop axé sur la vente'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Hésitant', 'Distant', 'Trop formel'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Excentrique', 'Abstrait', 'Exagéré'],
  },
  [LANGUAGE.bg]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['студен', 'корпоративен', 'остарял'],
    [TONE_OF_VOICE_TRAIT.friendly]: [
      'непрофесионален',
      'прекалено неформален',
      'прекалено неофициален',
    ],
    [TONE_OF_VOICE_TRAIT.authentic]: ['непрофесионален', 'прекалено случаен', 'неуважителен'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['безразличен', 'монотонен'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['преувеличен', 'твърде агресивен в продажбите'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['жаргонен', 'неуважителен'],
    [TONE_OF_VOICE_TRAIT.informative]: ['сух', 'прекалено техничен', 'многословен'],
    [TONE_OF_VOICE_TRAIT.confident]: ['арогантен', 'властен'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['драматичен', 'предполагащ', 'патронизиращ'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['неподходящ', 'Детинскиa', 'Банален'],
    [TONE_OF_VOICE_TRAIT.witty]: ['неуважителен', 'саркастичен', 'злобен'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Прекалено преувеличен', 'Прекалено насочен към продажбите'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Колеблив', 'Отдръпнат', 'Прекалено формален'],
    [TONE_OF_VOICE_TRAIT.creative]: ['чудат', 'абстрактен', 'Прекалено преувеличен'],
  },
  [LANGUAGE.cs]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['chladný', 'korporátní', 'staromódní'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['neprofesionální', 'příliš důvěrný', 'příliš neformální'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['neprofesionální', 'příliš neformální', 'neuctivý'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['lhostejný', 'monotónní'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['přehnaný', 'příliš prodejní'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Hovorový', 'Neuctivý'],
    [TONE_OF_VOICE_TRAIT.informative]: ['suchý', 'příliš technický', 'slovný'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arogantní', 'Panovačný'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramatický', 'Předpokládající', 'Svrchu se chovající'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Nevhodný', 'Dětinský', 'Triviální'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Neuctivý', 'Sarkastický', 'Jízlivý'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Přehnaný', 'Příliš prodejně zaměřený'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Váhavý', 'Vzdálený', 'Příliš formální'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Podivný', 'Abstraktní', 'Přehnaný'],
  },
  [LANGUAGE.da]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['kold', 'formel', 'gammeldags'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['uprofessionel', 'for familiær', 'Alt for afslappet'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['uprofessionel', 'Alt for afslappet', 'respektløs'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['ligeglad', 'monoton'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['overdrevet', 'for sælgende'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['slangagtig', 'Respektløs'],
    [TONE_OF_VOICE_TRAIT.informative]: ['tør', 'for teknisk', 'Ordflommet'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogant', 'Dominerende'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramatisk', 'Antagende', 'Nedladende'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Upassende', 'Barnlig', 'Klichefyldt'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Respektløs', 'Sarkastisk', 'Spydig'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Overdreven', 'For meget salgsorienteret'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Tøvende', 'Distant', 'Overdrevent formel'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Mærkelig', 'Abstrakt', 'Overdrevet'],
  },
  [LANGUAGE.nl]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['koud', 'corporatief', 'ouderwets'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['onprofessioneel', 'te vertrouwd', 'te informeel'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['onprofessioneel', 'te informeel', 'Oneerbiedig'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['onverschillig', 'eentonig'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['overdreven', 'te commercieel'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Slang', 'Respectloos'],
    [TONE_OF_VOICE_TRAIT.informative]: ['droog', 'te technisch', 'langdradig'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogant', 'Bazig'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramatisch', 'Veronderstellend', 'Betuttelend'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Ongepast', 'Kinderachtig', 'Flauw'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Respectloos', 'Sarcastisch', 'Bijtend'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Overdreven', 'Te verkoopgericht'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Aarzelend', 'Afstandelijk', 'Overdreven formeel'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Eigenzinnig', 'Abstract', 'Overdreven'],
  },
  [LANGUAGE.hu]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['hideg', 'vállalati', 'öregdiás'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['nem szakmai', 'túl közvetlen', 'túl laza'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['nem szakmai', 'túl laza', 'tiszteletlen'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['közömbös', 'monoton'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['túlzás', 'túl értékesítős'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['szlenges', 'Tiszteletlen'],
    [TONE_OF_VOICE_TRAIT.informative]: ['száraz', 'túl technikai', 'szószátyár'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogáns', 'Főnökösködő'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Drámai', 'Feltételező', 'Leereszkedő'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Nem helyénvaló', 'Gyerekes', 'Ciki'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Tiszteletlen', 'Szarkasztikus', 'Szúrós megjegyzés'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Túlzásba vitt', 'Túlzottan eladási fókuszú'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Habozó', 'Távolságtartó', 'Túlzottan hivatalos'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Furcsa', 'Absztrakt', 'Túlozó'],
  },
  [LANGUAGE.it]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['distaccato', 'aziendale', 'vecchio stile'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['non professionale', 'troppo familiare', 'troppo informale'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['non professionale', 'troppo informale', 'irrispettoso'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['indifferente', 'monotono'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['esagerato', 'troppo commerciale'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['slang', 'Irrispettoso'],
    [TONE_OF_VOICE_TRAIT.informative]: ['secco', 'troppo tecnico', 'verboso'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogante', 'Autoritario'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Drammatico', 'Presuntuoso', 'Paternalista'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Inappropriato', 'Infantile', 'Banale'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Irriverente', 'Sarcastico', 'Caustico'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Eccessivo', 'Troppo orientato alla vendita'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Esitante', 'Distante', 'Troppo formale'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Bizzarro', 'Astratto', 'Esagerato'],
  },
  [LANGUAGE.pl]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['Oschły', 'korporacyjny', 'staromodny'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['nieprofesjonalny', 'zbyt poufały', 'Zbyt swobodny'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['nieprofesjonalny', 'Zbyt swobodny', 'Lekceważący'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['ojczysty', 'monotonny'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['przesadzony', 'Zbyt handlowy'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Slangowy', 'Lekceważący'],
    [TONE_OF_VOICE_TRAIT.informative]: ['suchy', 'zbyt techniczny', 'przegadany'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arogancki', 'Władczy'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramatyczny', 'Zakładający z góry', 'Protekcjonalny'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Niewłaściwy', 'Dziecinny', 'Kiczowaty'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Lekceważący', 'Sarkastyczny', 'Złośliwy'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Przesadny', 'Zbyt nachalny sprzedażowo'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Niepewny', 'Dystansujący', 'Zbyt formalny'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Dziwaczny', 'Abstrakcyjny', 'Przesadny'],
  },
  [LANGUAGE.pt_br]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['distante', 'corporativo', 'antiquado'],
    [TONE_OF_VOICE_TRAIT.friendly]: [
      'não profissional',
      'demasiado familiar',
      'excessivamente casual',
    ],
    [TONE_OF_VOICE_TRAIT.authentic]: ['não profissional', 'excessivamente casual', 'desrespeitoso'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['indiferente', 'monótono'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['exagerado', 'demasiado comercial'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['chei de gírias', 'desrespeitoso'],
    [TONE_OF_VOICE_TRAIT.informative]: ['seco', 'demasiado técnico', 'prolixo'],
    [TONE_OF_VOICE_TRAIT.confident]: ['arrogante', 'mandão'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['dramático', 'presumido', 'paternalista'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['inapropriado', 'infantil', 'brega'],
    [TONE_OF_VOICE_TRAIT.witty]: ['irreverente', 'sarcástico', 'mordaz'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['exagerado', 'muito voltado para vendas'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['hesitante', 'distante', 'excessivamente formal'],
    [TONE_OF_VOICE_TRAIT.creative]: ['peculiar', 'abstrato', 'exagerado'],
  },
  [LANGUAGE.pt_pt]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['distante', 'corporativo', 'antiquado'],
    [TONE_OF_VOICE_TRAIT.friendly]: [
      'não profissional',
      'demasiado familiar',
      'excessivamente casual',
    ],
    [TONE_OF_VOICE_TRAIT.authentic]: ['não profissional', 'excessivamente casual', 'desrespeitoso'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['indiferente', 'monótono'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['exagerado', 'demasiado comercial'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['chei de gírias', 'desrespeitoso'],
    [TONE_OF_VOICE_TRAIT.informative]: ['seco', 'demasiado técnico', 'prolixo'],
    [TONE_OF_VOICE_TRAIT.confident]: ['arrogante', 'mandão'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['dramático', 'presumido', 'paternalista'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['inapropriado', 'infantil', 'brega'],
    [TONE_OF_VOICE_TRAIT.witty]: ['irreverente', 'sarcástico', 'mordaz'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['exagerado', 'muito voltado para vendas'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['hesitante', 'distante', 'excessivamente formal'],
    [TONE_OF_VOICE_TRAIT.creative]: ['peculiar', 'abstrato', 'exagerado'],
  },
  [LANGUAGE.ro]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['rece', 'corporativ', 'învechit'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['neprofesionist', 'prea familiar', 'prea lejer'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['neprofesionist', 'prea relaxat', 'lipsit de respect'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['indiferent', 'monoton'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['exagerat', 'prea vânzător'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['slangos', 'lipsit de respect'],
    [TONE_OF_VOICE_TRAIT.informative]: ['uscat', 'prea tehnic', 'cuvios'],
    [TONE_OF_VOICE_TRAIT.confident]: ['arogant', 'autoritar'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['dramatic', 'presumțios', 'paternalist'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['inadecvat', 'copilăresc', 'siropos'],
    [TONE_OF_VOICE_TRAIT.witty]: ['irreverențios', 'sarcastic', 'batjocoritor'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['exagerat', 'prea orientat spre vânzare'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['ezitant', 'distant', 'prea formal'],
    [TONE_OF_VOICE_TRAIT.creative]: ['excentric', 'abstract', 'exagerat'],
  },
  [LANGUAGE.ru]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['непрофессиональный', 'корпоративный', 'старомодный'],
    [TONE_OF_VOICE_TRAIT.friendly]: [
      'непрофессиональный',
      'чересчур фамильярный',
      'слишком неформальный',
    ],
    [TONE_OF_VOICE_TRAIT.authentic]: [
      'непрофессиональный',
      'слишком неформальный',
      'неуважительный',
    ],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['равнодушный', 'безразличный'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['преувеличенный', 'чрезмерный'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Сленговый', 'жаргонный'],
    [TONE_OF_VOICE_TRAIT.informative]: ['сухой', 'чрезмерно технический', 'многословный'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Высокомерный', 'Властный'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Драматичный', 'Самонадеянный', 'Патронизирующий'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Неподобающий', 'Детский', 'Пошлый'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Непочтительный', 'Саркастичный', 'Колкий'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Преувеличенный', 'Слишком нацеленный на продажу'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Нерешительный', 'Дистанцированный', 'Слишком формальный'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Чудаковатый', 'Абстрактный', 'Преувеличенный'],
  },
  [LANGUAGE.de_ch]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['distanziert', 'geschäftlich', 'altmodisch'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['unprofessionell', 'zu vertraut', 'Zu lässig'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['unprofessionell', 'Zu lässig', 'respektlos'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['gleichgültig', 'monoton'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['übertrieben', 'Zu werbend'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['Umgangssprachlich', 'Respektlos'],
    [TONE_OF_VOICE_TRAIT.informative]: ['trocken', 'zu technisch', 'Weitschweifig'],
    [TONE_OF_VOICE_TRAIT.confident]: ['Arrogant', 'Überheblich'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['Dramatisch', 'Anmassend', 'Herablassend'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['Unangebracht', 'Kindisch', 'Kitschig'],
    [TONE_OF_VOICE_TRAIT.witty]: ['Respektlos', 'Sarkastisch', 'Bissig'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['Übertrieben', 'Zu verkaufsorientiert'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['Zögerlich', 'Distanziert', 'Zu förmlich'],
    [TONE_OF_VOICE_TRAIT.creative]: ['Schrullig', 'Abstrakt', 'Übertrieben'],
  },
  [LANGUAGE.cmn]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['冷漠', '企业化', '过时的'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['不专业', '过于亲密', '过于随便'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['不专业', '过于随便', '不尊重'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['漠不关心', '单调'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['夸张', '过于推销'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['俚语的', '不尊重'],
    [TONE_OF_VOICE_TRAIT.informative]: ['干燥', '过于专业', '冗长'],
    [TONE_OF_VOICE_TRAIT.confident]: ['傲慢', '专横'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['夸张', '武断', '居高临下'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['不恰当', '幼稚', '俗气'],
    [TONE_OF_VOICE_TRAIT.witty]: ['无礼', '讽刺', '挖苦'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['过火', '过于推销'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['犹豫', '疏远', '过于正式'],
    [TONE_OF_VOICE_TRAIT.creative]: ['古怪', '抽象', '夸大'],
  },
  [LANGUAGE.yue]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['冷', '企業化', '過時'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['不專業', '過於親密', '過於隨便'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['不專業', '過於隨便', '不尊重'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['漠不關心', '單調'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['過於誇張', '太過推銷'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['俚語', '不尊重'],
    [TONE_OF_VOICE_TRAIT.informative]: ['乾', '過於技術化', '冗長'],
    [TONE_OF_VOICE_TRAIT.confident]: ['自大', '咄咄逼人'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['戲劇性', '武斷', '居高臨下'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['不適當', '幼稚', '俗套'],
    [TONE_OF_VOICE_TRAIT.witty]: ['無禮', '諷刺', '挖苦'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['誇張', '過於推銷'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['遲疑', '疏遠', '過於正式'],
    [TONE_OF_VOICE_TRAIT.creative]: ['古怪', '抽象', '誇大'],
  },
  [LANGUAGE.ja]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['冷たい', '企業的', '時代遅れ'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['非プロフェッショナル', '親しみやすすぎる', '非公式すぎる'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['非プロフェッショナル', '非公式すぎる', '失礼'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['無関心', '単調'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['過剰', '商業的すぎる'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['俗語', '失礼'],
    [TONE_OF_VOICE_TRAIT.informative]: ['乾いた', '技術的すぎる', '冗長'],
    [TONE_OF_VOICE_TRAIT.confident]: ['傲慢', '横柄'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['劇的', '思い込みが激しい', '見下す'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['不適切', '幼稚', '陳腐'],
    [TONE_OF_VOICE_TRAIT.witty]: ['失礼', '皮肉', '辛辣'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['過剰', '販売に過剰に焦点を当てすぎる'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['ためらい', '距離を置いた', '過度にフォーマル'],
    [TONE_OF_VOICE_TRAIT.creative]: ['奇妙', '抽象的', '過剰'],
  },
  [HIDDEN_LANGUAGE.he]: {
    [TONE_OF_VOICE_TRAIT.formal]: ['קר', 'תאגידי', 'מיושן'],
    [TONE_OF_VOICE_TRAIT.friendly]: ['לא מקצועי', 'יותר מדי קרוב', 'יותר מדי קליל'],
    [TONE_OF_VOICE_TRAIT.authentic]: ['לא מקצועי', 'יותר מדי קליל', 'לא מכבד'],
    [TONE_OF_VOICE_TRAIT.matterOfFact]: ['אדיש', 'מונוטוני'],
    [TONE_OF_VOICE_TRAIT.enthusiastic]: ['מוגזם', 'יותר מדי מכירתי'],
    [TONE_OF_VOICE_TRAIT.conversational]: ['עמוס בסלנג', 'לא מכבד'],
    [TONE_OF_VOICE_TRAIT.informative]: ['יבש', 'טכני מידי', 'עמוס בפרטים'],
    [TONE_OF_VOICE_TRAIT.confident]: ['יהיר', 'שתלטן'],
    [TONE_OF_VOICE_TRAIT.empathetic]: ['דרמטי', 'מניח הנחות', 'מתנשא'],
    [TONE_OF_VOICE_TRAIT.humorous]: ['לא הולם', 'ילדותי', 'קיטשי'],
    [TONE_OF_VOICE_TRAIT.witty]: ['לא מכבד', 'סרקסטי', 'עוקצני'],
    [TONE_OF_VOICE_TRAIT.persuasive]: ['מוגזם', 'מכירתי מדי'],
    [TONE_OF_VOICE_TRAIT.respectful]: ['מהוסס', 'מרוחק', 'רשמי מידי'],
    [TONE_OF_VOICE_TRAIT.creative]: ['מוזר', 'מופשט', 'מוגזם'],
  },
};

export const normalizeTraitButNot = (traitButNot) => {
  return trimStart(replace(traitButNot, /^(overly|too) /, ''));
};

export const getToneOfVoiceTraitButNots = (trait, language) => {
  if (NON_ENGLISH_TOV_TRAIT_BUT_NOT[language]?.[trait]) {
    return NON_ENGLISH_TOV_TRAIT_BUT_NOT[language][trait];
  } else {
    return TOV_TRAIT_BUT_NOT_MAP[trait] || [];
  }
};

export const toneOfVoiceTraitHasButNots = (trait, language) =>
  getToneOfVoiceTraitButNots(trait, language).length > 0;

export const TONE_OF_VOICE_TRAIT_MAX_COUNT = 5;

export const getToneOfVoiceTraits = (language) => {
  if (TONE_OF_VOICE_TRAIT_NON_ENGLISH[language]) {
    return Object.keys(TONE_OF_VOICE_TRAIT_NON_ENGLISH[language]);
  }

  return Object.values(TONE_OF_VOICE_TRAIT);
};

export const getTraitLabel = (trait, language) => {
  if (
    TONE_OF_VOICE_TRAIT_NON_ENGLISH[language] &&
    TONE_OF_VOICE_TRAIT_NON_ENGLISH[language][trait]
  ) {
    return TONE_OF_VOICE_TRAIT_NON_ENGLISH[language][trait];
  }

  if (trait === 'matter-of-fact') {
    return TONE_OF_VOICE_TRAIT.matterOfFact;
  }
  return TONE_OF_VOICE_TRAIT[trait];
};
export const getEnglishTraitButNot = (butNot, language, trait) => {
  if (NON_ENGLISH_TOV_TRAIT_BUT_NOT[language]?.[trait]) {
    const index = NON_ENGLISH_TOV_TRAIT_BUT_NOT[language][trait].indexOf(butNot);
    return TOV_TRAIT_BUT_NOT_MAP[trait][index];
  }

  return butNot;
};

export const getNonEnglishTraitButNot = (butNot, language, trait) => {
  if (NON_ENGLISH_TOV_TRAIT_BUT_NOT[language]?.[trait]) {
    const index = TOV_TRAIT_BUT_NOT_MAP[trait].indexOf(butNot);
    return NON_ENGLISH_TOV_TRAIT_BUT_NOT[language][trait][index];
  }
  return butNot;
};
